<template>
  <div class="images">
      <img v-bind:src="Source"/> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  props: {
    Source: String
  },
  components: {
    
  },
  watch: {
   
  }
};
</script>
